import { marqueeItems } from '../data/portfolio';

export default function Marquee() {
    const row = [...marqueeItems, ...marqueeItems];
    return (
        <div className="relative z-10 overflow-hidden border-y border-white/[0.08] bg-ink/95 py-5" data-testid="marquee">
            <div className="marquee-track flex w-max items-center gap-10">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center gap-10 whitespace-nowrap">
                        <span className="font-display text-lg font-semibold uppercase tracking-wide text-snow/85 md:text-2xl">
                            {item}
                        </span>
                        <span className="text-sm text-neon/70">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
